module.exports = __webpack_public_path__ + "static/media/part5.fb633d03.png";


//////////////////
// WEBPACK FOOTER
// ./src/wbstdt/imgs/partners/part5.png
// module id = 106
// module chunks = 0